<template>
  <div class="text-center">
    <v-layout justify-center>
      <v-flex xs12 sm10 md8 lg6 xl4>
        <v-card flat outlined class="pa-5">
          <div>
            <p class="display-1 red--text text--darken-3">Glossary Quizzes</p>
            <p>
              Quiz yourself to review important terms and images from <a href="http://www.hematologyoutlines.com/" target="_blank">Hematology Outlines</a>.
            </p>

            <p class="headline mt-5 mb-1">
              Progress
            </p>
            <div class="mt-0 mx-5 px-5 mb-5">
              <v-progress-linear color="red darken-2"  :value="((($store.state.termCountTotal - $store.state.terms.length) + ($store.state.imageCountTotal - $store.state.images.length)) / ($store.state.termCountTotal+$store.state.imageCountTotal)) * 100" height="10">
              </v-progress-linear>
              <p class="caption">
                {{$store.state.terms.length + $store.state.images.length}} left of {{$store.state.termCountTotal + $store.state.imageCountTotal}} terms and images
              </p>
            </div>


            <p class="headline mt-5">
              Quizzes
            </p>

            <div class="boxes d-inline-block">
              <v-card
                flat
                :disabled="$store.state.images.length == 0"
                @click="$router.push({name: 'Images'})"
                 ripple class="text-center mr-2  py-5 pa-2 d-inline-block" outlined width="140" height="140">
                <v-icon color="red darken-3" x-large>mdi-image-multiple</v-icon>
                <p class="title red--text text--darken-3">Image Quiz</p>
                <v-progress-linear :value="(($store.state.imageCountTotal - $store.state.images.length) / $store.state.imageCountTotal) * 100"></v-progress-linear>
                <p v-if="$store.state.images.length != 0" class="caption">{{$store.state.images.length}} left of {{$store.state.imageCountTotal}}</p>
                <p v-else class="caption">Complete</p>
              </v-card>
              <v-card
                flat
                @click="$router.push({name: 'Terms'})"
                ripple class="text-center ml-2 py-5 pa-2 d-inline-block" outlined width="140" height="140">
                <v-icon color="red darken-3" x-large>mdi-book-open-outline</v-icon>
                <p class="title red--text text--darken-3">Term Quiz</p>

                <v-progress-linear :value="(($store.state.termCountTotal - $store.state.terms.length) / $store.state.termCountTotal) * 100"></v-progress-linear>

                <p class="caption">{{$store.state.terms.length}} left of {{$store.state.termCountTotal}}</p>
              </v-card>
            </div>

            <div class="text-right mt-5 pt-5">
              <v-menu offset-y offset-x>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    x-small
                    outlined
                    color="grey"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    Tap/Click to Restart
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="update()">
                    <v-list-item-title>Reset All Progress</v-list-item-title>
                  </v-list-item>

                  </v-list-item>
                </v-list>
              </v-menu>

            </div>




          </div>
        </v-card>
        <span class="grey--text text--lighten-2">Version: {{$store.state.appVersion}}</span>

      </v-flex>


    </v-layout>
    <v-layout justify-center>
      <v-flex xs12 sm10 md8 lg6 xl4>
        <v-card flat outlined v-if="showUpdateButton" class="text-center mt-3 pa-5">
          <p class="headline blue--text">
            Update Available
          </p>
          <p>
            We have updated the content.
            To make the update, we have to reset your progress.
          </p>
          <v-switch class="pl-3" color="blue darken-2" v-model="progressAck" label="I understand my progress will be lost">

          </v-switch>

          <v-btn :loading="updateApplying" :disabled="!progressAck" small @click="update()">
            Update
          </v-btn>

        </v-card>
      </v-flex>


    </v-layout>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Learn',
  data() {
    return {
      showUpdateButton: false,
      progressAck: false,
      updateApplying: false,
    }
  },
  mounted() {

      console.log('checking version')
      axios.get('https://us-central1-hematologyoutlines-flashcards.cloudfunctions.net/widgets/appVersion')
      .then(result => {
        console.log('server:',result.data)
        console.log('local:',result.data)
        if (result.data != this.$store.state.appVersion) {
          this.showUpdateButton = true
        }
      })


  },
  methods: {
    update() {
      this.updateApplying = true
      let message = JSON.stringify({
        test: 'test'
      })

      try {this.$iosHandlers.update.postMessage(message)
      }
      catch(err) {
        this.$store.dispatch("deleteCookie")
        location.reload();
      }




    }
  }
}
</script>

<style>
.boxes{
  display: inline;
}
</style>
